/* What kind of thing has been typed into the postcode box. Mirrors the
 * server's system/server/lib/postcodes.js — CHANGE ONE, CHANGE THE OTHER. */

const FULL = /^([A-Z]{1,2}\d[A-Z\d]?)\s*(\d[A-Z]{2})$/;
const OUTCODE = /^[A-Z]{1,2}\d[A-Z\d]?$/;
const AREA = /^[A-Z]{1,2}$/;
const PARTIAL = /^([A-Z]{1,2}\d[A-Z\d]?)\s+(\d[A-Z]{0,1})$/;
const PLACE = /^[A-Z][A-Z' .-]{2,}$/;

const clean = (input) => String(input || '').trim().toUpperCase().replace(/\s+/g, ' ');

// 'full' | 'outcode' | 'partial' | 'area' | 'place' | 'invalid' | null (empty)
export const postcodeKind = (input) => {
    const v = clean(input);
    if (!v) return null;
    if (FULL.test(v)) return 'full';
    if (AREA.test(v)) return 'area';
    if (OUTCODE.test(v)) return 'outcode';
    if (PARTIAL.test(v)) return 'partial';
    if (PLACE.test(v)) return 'place';
    return 'invalid';
};

export const validatePostcode = (input) =>
    postcodeKind(input) === 'invalid'
        ? 'Enter a postcode (e.g. BS, BS1, BS1 1AA) or a town name'
        : null;

// A radius needs a centre point: anything but a bare area (B, BS) works.
export const canCentreRadius = (input) =>
    ['full', 'outcode', 'partial', 'place'].includes(postcodeKind(input));

// "BS1 1AA" / "BS11AA" / "BS1" -> "BS"; null for a place name or area.
export const areaOf = (input) => {
    const kind = postcodeKind(input);
    if (!['full', 'outcode', 'partial'].includes(kind)) return null;
    return clean(input).match(/^[A-Z]{1,2}/)[0];
};
